import React from 'react';
import clsx from 'clsx';

const AdxButton = ({
  children,
  className,
  iconClassName,
  strokeClassName,
  disabled,
  ...rest
}) => {
  return (
    <button
      className={clsx(
        'rounded-full group flex items-center text-[20px] font-normal pr-1 py-1 pl-7 border-2 transition-all duration-260 w-fit',
        !disabled && 'bg-primary hover:bg-hover hover:text-hover-foreground border-primary text-white',
        disabled && 'bg-gray-200 border-gray-200 text-black',
        className
      )}
      disabled={disabled}
      {...rest}
    >
      <span className='mx-auto self-center w-[calc(100%-2.5rem)] mr-3'>
        {children}
      </span>
      <div
        className={clsx(
          'rounded-full flex items-center justify-center w-10 h-10',
          !disabled && 'bg-white group-hover:bg-hover-foreground',
          disabled && 'bg-gray-300',
          iconClassName
        )}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          className={clsx(
            !disabled && 'stroke-inherit text-black group-hover:text-hover',
            disabled && 'text-gray-600',
            strokeClassName
          )}
        >
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='m9 18l6-6l-6-6'
          />
        </svg>
      </div>
    </button>
  );
};

export default AdxButton;